import { RouterModule, Routes } from '@angular/router';
import { adminRoutes } from './admin/admin.routes';
import { sponsorRoutes } from './sponsor/sponsor.routes';
import { investigatorRoutes } from './investigator/investigator.routes';
import { dashboardRoutes, globalDashboardRoutes } from './dashboard';
import { authenticationRoutes } from './authentication/authentication.routes';
import { UserAuthenticatedGuard } from './authentication/user-authenticated-guard';
import { corporateRoutes } from './corporate/corporate.routes';
import { UserAcceptedTermsGuard } from './corporate/user-accepted-terms-guard';
import { sampleTrackingRoutes } from './sample-tracking/sample-tracking.routes';
import { sampleManagementRoutes } from './sample-management/sample-management.routes';

export const routes: Routes = [
    ...authenticationRoutes,
    ...globalDashboardRoutes,
    {
        path: '',
        canActivate: [UserAuthenticatedGuard],
        children: [
            ...corporateRoutes,
            {
                path: '',
                canActivate: [UserAcceptedTermsGuard],
                children: [
                    ...dashboardRoutes,
                    ...adminRoutes,
                    ...sponsorRoutes,
                    ...sampleTrackingRoutes,
                    ...sampleManagementRoutes,
                    ...investigatorRoutes,
                ]
            }]
    },
    {
        path: '**',
        redirectTo: '/'
    }
];

/*
Routing settings should be registered in bootstrap, so this is the place to put them all in one providers array
*/

export const routing = RouterModule.forRoot(routes);